var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRestart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6002_249)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4365 15.6655C22.4326 10.963 20.2386 5.5327 15.5361 3.5366C10.8335 1.5405 5.40323 3.73448 3.40713 8.43701C1.59555 12.7048 3.23539 17.5735 7.06987 19.9282C7.42284 20.145 7.53326 20.6069 7.3165 20.9598C7.09974 21.3128 6.63788 21.4232 6.28491 21.2065C1.82737 18.469 -0.0795511 12.8121 2.02637 7.85091C4.34616 2.38582 10.6571 -0.163952 16.1222 2.15584C21.5872 4.47564 24.137 10.7865 21.8172 16.2516C20.9111 18.3862 19.3946 20.0776 17.5578 21.2063C17.2049 21.4232 16.743 21.3129 16.5261 20.96C16.3092 20.6071 16.4195 20.1452 16.7724 19.9284C18.3525 18.9574 19.6561 17.5039 20.4365 15.6655Z",
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.75 21C22.75 21.4142 22.4142 21.75 22 21.75H17.6C16.8544 21.75 16.25 21.1456 16.25 20.4V16C16.25 15.5858 16.5858 15.25 17 15.25C17.4142 15.25 17.75 15.5858 17.75 16V20.25H22C22.4142 20.25 22.75 20.5858 22.75 21Z",
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5117 21.4413C12.8196 21.7184 12.8446 22.1926 12.5675 22.5005L12.5575 22.5116C12.2804 22.8195 11.8062 22.8445 11.4983 22.5674C11.1904 22.2903 11.1654 21.8161 11.4425 21.5082L11.4525 21.4971C11.7296 21.1892 12.2038 21.1642 12.5117 21.4413Z",
    fill: "#BFBFBF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6002_249"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestart);
export default __webpack_public_path__ + "static/media/restart.43125b4705d48e230e971f1a95bcb5f0.svg";
export { ForwardRef as ReactComponent };